const { default: AppConstants } = require("../gorillaboy/AppConstants");

(function () {
    'use strict';
    angular.module('GorillaBoy.directives')
        .directive('topBanner',
            ['$rootScope',
                'localStorageService',
                'AppConstants',
                function ($rootScope, localStorageService, AppConstants) {

                    return {
                        templateUrl: './top-banner/top_banner.html',
                        link: function (scope, element, attrs) {
                            // Initial check for banner visibility
                            scope.displayBanner = $rootScope.isBannerVisible();
                            
                            // Watch for changes in AwsAccountStatus
                            scope.$watch(function() {
                                return $rootScope.AwsAccountStatus;
                            }, function(newValue, oldValue) {
                                if (newValue !== oldValue) {
                                    scope.displayBanner = $rootScope.isBannerVisible();
                                }
                            });
                            
                            // Listen for events that might affect banner visibility
                            var unregisterListener = $rootScope.$on('awsStatusChanged', function() {
                                scope.displayBanner = $rootScope.isBannerVisible();
                            });
                            
                            // Clean up the listener when the scope is destroyed
                            scope.$on('$destroy', function() {
                                unregisterListener();
                            });
                        }
                    };
                }
            ]
        )
}());
